import jwtAuthAxios from "./auth/jwtAuth";

// Zonas de una bodega: los sectores que se pintan en el plano y que definen en
// que momento del recorrido se camina cada parte.
const warehouseZoneServices = {};

warehouseZoneServices.getZones = async (centreId) => {
    const { data } = await jwtAuthAxios.get(`/warehouse_zones?centre_id=${centreId}`);
    return data;
};

warehouseZoneServices.createZone = async (payload) => {
    const { data } = await jwtAuthAxios.post(`/warehouse_zones`, { warehouse_zone: payload });
    return data;
};

warehouseZoneServices.updateZone = async (id, payload) => {
    const { data } = await jwtAuthAxios.put(`/warehouse_zones/${id}`, { warehouse_zone: payload });
    return data;
};

warehouseZoneServices.deleteZone = async (id) => {
    const { data } = await jwtAuthAxios.delete(`/warehouse_zones/${id}`);
    return data;
};

export default warehouseZoneServices;
